module.exports = __webpack_public_path__ + "static/media/2008-normalized.c7cad22f.csv";